import React from 'react'
import './Logo.css';

const Logo = () => {
 return (
  <div className="logo-container">
   <div className="logo-parker">
    <div className="shape">
      
       <div className="symbol">
       <p className="yoyo text-white">D </p>
       </div>
      
    </div>
    <div className="text">
      <p className="texttop">
        Company
      </p>
    </div>
   </div>
  </div>
 )
}

export default Logo
